import { computed, toValue, type MaybeRefOrGetter } from 'vue';

import { MessageAttachmentType, type MessageInfoSchemaType } from '../model';

type MessageAttachment = NonNullable<MessageInfoSchemaType['attachments']>[number];
type MessageAttachmentWithIndex = {
  attachment: MessageAttachment;
  attachmentIndex: number;
};

const useMessageAttachmentsByType = (
  _attachments: MaybeRefOrGetter<MessageInfoSchemaType['attachments']>,
) => {
  const attachments = computed<MessageInfoSchemaType['attachments']>(() => toValue(_attachments));

  const imageAttachments = computed<MessageAttachmentWithIndex[]>(() =>
    attachments.value
      .filter(({ type }) => type === MessageAttachmentType.IMAGE)
      .map((attachment, idx) => ({ attachment, attachmentIndex: idx })),
  );

  const fileAttachments = computed<MessageAttachment[]>(() =>
    attachments.value.filter(({ type }) => type === MessageAttachmentType.FILE),
  );

  return { imageAttachments, fileAttachments };
};

export { useMessageAttachmentsByType };
